export default function AreaReportScreen() {
  return null;
}
